import React from 'react';

const Results = () => {


  return <div>Ergebnisse werden geladen…</div>;
};

export default Results;
